<template>
  <div>
    <el-form ref="formRef" :model="form" label-width="2.6rem">
      <el-form-item
        label="姓名:"
        class="border"
        prop="name"
        :rules="[
          { required: true, message: '请填写姓名' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ]"
      >
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item
        label="联系电话"
        class="border"
        prop="phoneNumber"
        :rules="[
          { required: true, message: '请填写联系电话' },
          { validator: isPhone },
        ]"
      >
        <el-input v-model="form.phoneNumber"></el-input>
      </el-form-item>
      <el-form-item
        label="毕业院校"
        class="border"
        prop="graduatedSchool"
        :rules="[
          { required: true, message: '请填写毕业院校' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'change',
          },
        ]"
      >
        <el-input v-model="form.graduatedSchool"></el-input>
      </el-form-item>
      <el-form-item
        label="毕业时间"
        class="border"
        prop="guaduatedTime"
        :rules="[{ required: true, message: '请填写毕业时间' }]"
      >
        <el-col :span="11">
          <el-date-picker
            v-model="form.guaduatedTime"
            type="date"
            placeholder="选择时间"
            style="width: 100%; z-index: 9999"
            :editable="false"
            value-format="yyyy/MM/dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item
        label="学历"
        class="border"
        prop="education"
        :rules="[{ required: true, message: '请选择学历' }]"
      >
        <!-- <el-input v-model="form.education"></el-input> -->
        <el-select v-model="form.education" placeholder="选择学历">
          <el-option label="专科" value="0"></el-option>
          <el-option label="本科" value="1"></el-option>
          <el-option label="硕士" value="2"></el-option>
          <el-option label="博士" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="专业"
        class="border"
        prop="professional"
        :rules="[
          { required: true, message: '请填写专业' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'change',
          },
        ]"
      >
        <el-input v-model="form.professional"></el-input>
      </el-form-item>
      <el-form-item
        label="应聘岗位"
        class="border"
        prop="applyPositionName"
        :rules="[{ required: true, message: '请选择应聘岗位' }]"
      >
        <el-input v-model="form.applyPositionName" disabled></el-input>
      </el-form-item>
      <el-form-item
        label="上传简历"
        prop="fileId"
        :rules="[{ required: true, message: '请上传简历' }]"
      >
        <el-upload
          class="upload"
          :action="url"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :before-remove="beforeRemove"
          :before-upload="beforeUpload"
          :limit="1"
          :file-list="fileList"
        >
          <el-button type="primary">上传</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item class="btn" style="text-align: center">
        <el-button type="primary" @click="validateAndShowVCode"
          >提交信息</el-button
        >
        <el-button @click="onBack">返回</el-button>
      </el-form-item>
    </el-form>
    <Vcode :show="isShow" @success="onSubmit" @close="onClose" />
  </div>
</template>

<script>
import Vcode from "vue-puzzle-vcode"; //https://github.com/javaLuo/vue-puzzle-vcode/blob/HEAD/README3.md
import { BASE_URL, SAVE_RESUME, UPLOAD } from "@/service/api";
import {compressAccurately} from 'image-conversion'
export default {
  components: { Vcode },
  props: {},
  data() {
    return {
      form: {
        name: "",
        phoneNumber: "",
        education: "",
        graduatedSchool: "",
        guaduatedTime: "",
        professional: "",
        applyPosition: "",
        applyPositionName: "",
        fileId: "",
      },
      fileList: [],
      url: BASE_URL + UPLOAD,
      isShow: false,
      pickerOptions: {
        disabledDate(time) {
          return false;//time.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    isPhone(rule, value, callback) {
      rule;
      let patter =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!patter.test(value)) {
        return callback(new Error("请填写正确的手机号"));
      } else {
        callback();
      }
    },
    validateAndShowVCode() {
      //校验表单，弹出验证框
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.isShow = true;
        } else {
          return false;
        }
      });
    },

    onClose() {
      this.isShow = false;
    },
    onSubmit() {
      this.isShow = false;
      const params = new URLSearchParams();
      params.append("name", this.form.name);
      params.append("phoneNumber", this.form.phoneNumber);
      params.append("education", this.form.education);
      params.append("graduatedSchool", this.form.graduatedSchool);
      params.append("guaduatedTime", this.form.guaduatedTime);
      params.append("professional", this.form.professional);
      params.append("applyPosition", this.form.applyPosition);
      params.append("applyPositionName", this.form.applyPositionName);
      params.append("fileId", this.form.fileId);
      fetch(BASE_URL + SAVE_RESUME, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params,
      })
        .then((rsp) => {
          rsp.json().then((data) => {
            console.log(data);
            if (data.code == 0) {
              this.$message({ message: data.msg, type: "success" });
              this.onBack();
            } else {
              this.$message({ message: data.msg, type: "warning" });
            }
          });
        })
        .catch((e) => {
          this.$message({ message: e, type: "warning" });
        });
    },
    onBack() {
      //子组件调用父组件方法
      this.$emit("hidden", "值");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleSuccess(response) {
      this.form.fileId = response;
      console.log(response);
    },
    beforeRemove(file) {
      return this.$confirm(`删除文件 ${file.name} ?`, { center: true });
    },
    beforeUpload(file) {
      return new Promise((resolve) => {
        if (file.type.indexOf("image") !== -1) {
          let _URL = window.URL || window.webkitURL;
          let isLt2M = file.size / 1024 / 1024 > 2; // 判定图片大小是否小于2MB
          // 这里需要计算出图片的长宽
          let img = new Image();
          img.onload = function () {
            file.width = img.width; // 获取到width放在了file属性上
            file.height = img.height; // 获取到height放在了file属性上
            let valid = img.width > 2000; // 图片宽度大于2000
            // console.log(11, file)
            // 这里我只判断了图片的宽度,compressAccurately有多个参数时传入对象
            if (valid || isLt2M) {
              compressAccurately(file, {
                size: 400,
                width: 2000,
              }).then((res) => {
                // console.log(33, res)
                resolve(res);
              });
            } else resolve(file);
          }; // 需要把图片赋值
          img.src = _URL.createObjectURL(file);
        } else {
          resolve(file);
        }
      });
    },
    updatePosition(res) {
      this.form.applyPosition = res.id;
      this.form.applyPositionName = res.name;
    },
  },
};
</script>
<style scoped>
/deep/ .el-input--suffix .el-input__inner {
  padding-right: 1px;
  width: 200px;
}
.border /deep/ .el-form-item__content {
  border: 1px solid #dfdfdf;
}
.btn /deep/ .el-form-item__content {
  display: contents;
}
.upload {
  /* width: 70vw; */
}
.el-upload {
  /* height: 400px; */
}
/deep/ .el-upload-list {
  width: 50vw;
  height: 30px;
  border: 1px solid #dfdfdf;
  margin-right: 10px;
  float: left;
}
/deep/ .el-upload-list__item {
  margin-top: unset;
}
/deep/ .el-progress--line {
  margin-top: 2px !important;
}
/deep/ .el-input__suffix {
  display: none !important;
}
/deep/ .el-icon-close-tip {
  display: none !important;
}
</style>
